function handleTopCritics(critics) {
    let defaultError = [];

    // Remover alertas
    const listWithoutWarnings = (critics || []).filter(({ tipo }) => {
        const isWarning = tipo === 2;

        return !isWarning;
    });

    // Caso tenha critias do tipo erro incluir mensagem genérica de erro
    if (listWithoutWarnings.length > 0) {
        defaultError = [
            {
                tipo: 1,
                descricao: 'Identificamos erros em sua movimentação. Por favor, reveja os dados',
                codigo: '#DEFAULT_ERROR',
            },
        ];
    }

    return [...defaultError, ...listWithoutWarnings];
}

export { handleTopCritics };
